export const questions = [
  {
    title: "Is there a free trial available ?",
    text: "Yes, you can try us for free for 30 days. If you want, we’llprovide you with a free, personalized 30-minute onboarding callto get you up and running as soon as possible.",
  },
  {
    title: "Can I change my plan later ?",
    text: "Yes, you can try us for free for 30 days. If you want, we’llprovide you with a free, personalized 30-minute onboarding callto get you up and running as soon as possible.",
  },
  {
    title: "What is your cancellation policy ?",
    text: "Yes, you can try us for free for 30 days. If you want, we’llprovide you with a free, personalized 30-minute onboarding callto get you up and running as soon as possible.",
  },
  {
    title: "Can other info be added to an invoice ?",
    text: "Yes, you can try us for free for 30 days. If you want, we’llprovide you with a free, personalized 30-minute onboarding callto get you up and running as soon as possible.",
  },
  {
    title: "How does billing work ?",
    text: "Yes, you can try us for free for 30 days. If you want, we’llprovide you with a free, personalized 30-minute onboarding callto get you up and running as soon as possible.",
  },
];
